/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ListSubObjectivesByObjectiveQueryResponse, ListSubObjectivesByObjectivePathParams, ListSubObjectivesByObjective400, ListSubObjectivesByObjective401, ListSubObjectivesByObjective403, ListSubObjectivesByObjective404, ListSubObjectivesByObjective409, ListSubObjectivesByObjective500 } from "../../types/planningTasksController/ListSubObjectivesByObjective.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getListSubObjectivesByObjectiveUrl(organizationId: ListSubObjectivesByObjectivePathParams["organizationId"], objectiveId: ListSubObjectivesByObjectivePathParams["objectiveId"]) {
  const res = { method: 'GET', url: `/api/organizations/${organizationId}/objectives/${objectiveId}/sub-objectives` as const }
  return res
}

/**
 * @summary List sub-objectives by objective
 * {@link /api/organizations/:organizationId/objectives/:objectiveId/sub-objectives}
 */
export async function listSubObjectivesByObjective(organizationId: ListSubObjectivesByObjectivePathParams["organizationId"], objectiveId: ListSubObjectivesByObjectivePathParams["objectiveId"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListSubObjectivesByObjectiveQueryResponse, ResponseErrorConfig<ListSubObjectivesByObjective400 | ListSubObjectivesByObjective401 | ListSubObjectivesByObjective403 | ListSubObjectivesByObjective404 | ListSubObjectivesByObjective409 | ListSubObjectivesByObjective500>, unknown>({ method : "GET", url : getListSubObjectivesByObjectiveUrl(organizationId, objectiveId).url.toString(), ... requestConfig })
  return res.data
}